import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import {
  Form,
  SidebarFormHeader,
  TextfieldElement,
  SelectElement,
  SidebarFormFooter,
  withAuthentication,
  withProvidersApi,
  DateISO8601Element,
  AutocompleteTextfieldApiElement,
} from "cw-styleguide-react";
import withAssets from "../../../components/hoc/withAssets";
import i18n from "../../../i18n";

class ContactsManageFilterForm extends Component {
  /**
   * componentDidMount.
   */
  componentDidMount() {}
  render() {
    return (
      <Form theme={["sidebar"]} classes={["sidebar--can-collapse"]}>
        <SidebarFormHeader
          heading={this.props.t("styleguide:forms.filterBy")}
          searchButtonText={this.props.t("styleguide:forms.applyFilters")}
          handleSubmit={this.props.handleSubmit}
          handleReset={this.props.handleReset}
        />
        <div className="form__body">
          {/* Name */}
          <TextfieldElement
            size={"medium"}
            label={this.props.t(
              "local:view.contacts.manage.filters.contactName.label"
            )}
            id={"contactName"}
            name={"contactName"}
            placeholder={this.props.t(
              "local:view.contacts.manage.filters.contactName.placeholder"
            )}
            value={this.props.values.contactName}
            onChange={this.props.handleChange}
            onKeyPress={this.context.preventDefaultOnEnter}
          />

          {/* Email */}
          <TextfieldElement
            size={"medium"}
            label={this.props.t(
              "local:view.contacts.manage.filters.email.label"
            )}
            id={"email"}
            name={"email"}
            placeholder={this.props.t(
              "local:view.contacts.manage.filters.email.placeholder"
            )}
            value={this.props.values.email}
            onChange={this.props.handleChange}
            onKeyPress={this.context.preventDefaultOnEnter}
          />

          {/* Status */}
          <SelectElement
            size={"medium"}
            label={this.props.t(
              "local:view.contacts.manage.filters.status.label"
            )}
            id={"status"}
            name={"status"}
            value={this.props.values.status}
            onChange={this.props.handleChange}
            grouped={true}
            options={[
              {
                value: "",
                label: this.props.t("styleguide:forms.all"),
              },
            ].concat(this.props.courses.assets.contacts.statuses)}
          />

          {/* Provider */}
          {!this.props.authentication.hasRole("Courses_Provider") && (
            <AutocompleteTextfieldApiElement
              api={this.props.providersApiGetEndpoint("providers_api_provider")}
              authorize={true}
              size={"large"}
              name={"atlasAccount"}
              label={this.props.t(
                "local:view.contacts.manage.filters.atlasAccountId.label"
              )}
              disabled={this.props.authentication.hasRole("Courses_Provider")}
              queryParameter={"name"}
              acceptLanguage={i18n.language}
              keyField={"atlasAccountId"}
              valueField={"providerName"}
              placeholder={this.props.t(
                "local:view.contacts.manage.filters.atlasAccountId.placeholder"
              )}
              value={this.props.values.atlasAccountId}
              keyword={this.props.values.atlasAccountLabel}
              onChange={this.props.handleChange}
            />
          )}

          {/* Confirmed date */}
          <DateISO8601Element
            id={"confirmationDate"}
            name={"confirmationDate"}
            label={this.props.t(
              "local:view.contacts.manage.filters.confirmationDate.label"
            )}
            value={this.props.values.confirmationDate}
            onChange={this.props.handleChange}
          />

          <SidebarFormFooter
            handleSubmit={this.props.handleSubmit}
            handleReset={this.props.handleReset}
            searchButtonText={this.props.t("styleguide:forms.applyFilters")}
          />
        </div>
      </Form>
    );
  }
}

export default withProvidersApi(process.env)(
  withAuthentication(
    withAssets(withTranslation("local")(ContactsManageFilterForm))
  )
);
